<div class="modal-footer d-flex flex-column flex-sm-row justify-content-between">
  <button
    type="button"
    class="btn btn-outline-primary mb-2 mb-sm-0"
    (click)="activeModal.close('Aceptar')"
  >
    Aceptar
  </button>
  <button type="button" class="btn btn-success" (click)="Descargar()">
    Descargar
  </button>
</div>

<div
  class="cuerpo"
  id="cuerpo"
>
  <div id="cuerpo1" style="
  width: 210mm;
  padding: 10mm;
  margin: 5px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  position: relative;"
>
    <div
      class="cabecera"
      style="
        display: flex;
        align-items: center;
        text-align: center;
        margin-bottom: 20px;
        border-style: solid;
        border-width: 2px;
      "
    >
    <img class="image-whastapp"  src="./../../../assets/images/cosede.png" style=" margin: 8px;
    width: 20%;
    max-width: 150px; 
    margin-right: 20px; " alt="image-whastapp">
      <div class="texto" style="width: 100%;">
      
        <div class="nombre-empresa" style="font-weight: bold; font-size: 15px ; align-items: center;
        text-align: center;">
          COOPERATIVA DE AHORRO Y CREDITO RIOBAMBA LTDA
        </div>
        <div class="ruc" style="font-size: 18px">0690045389001</div>
        <div class="estado-cuenta" style="font-size: 14px">
          ESTADO DE CUENTA
        </div>
        <div style="font-size: 10px">
          Consulta de movimientos de cuenta del {{fechaInicio | date:'dd-MM-yyyy'}} a {{fechaFin | date:'dd-MM-yyyy'}}
        </div>
      </div>
    </div>
    <div
      class="informacion"
      style="
        font-size: 12px;
        margin-bottom: 10px;
        border-style: solid;
        border-width: 2px;
        padding-top: 6px;
        padding-bottom: 6px;
        display: flex;
      "
    >
      <div class="grupo-info" style="width: 50%; padding: 5px;">
        <div class="columna">
          <div class="etiqueta-info" style="font-weight: 100 ">
            Nombre del Cliente:
          </div>
          <div class="etiqueta-info" style="font-weight: 100">
            Nombre de la Cuenta:
          </div>
          <div class="etiqueta-info" style="font-weight: 100">
            Código de Cliente:
          </div>
          <div class="etiqueta-info" style="font-weight: 100">
            No. de Cuenta:
          </div>
        </div>
      </div>
      <div class="grupo-info" style="width: 50%; padding: 5px;">
        <div class="columna">
          <div
          class="contenedor-dato"
          style="display: flex; align-items: center"
        >
            <div style="width: 90%; font-weight: bold; white-space: nowrap">
              {{estadoCuenta?.cabeceraEstadoCuenta?.nombreCliente ?? '-'}}
            </div>
          </div>
          <div
            class="contenedor-dato"
            style="display: flex; align-items: center"
          >
            <div style="width: 90%; font-weight: bold; white-space: nowrap">
              {{estadoCuenta?.cabeceraEstadoCuenta?.nombreCuenta || '-'}}
            </div>
          </div>
          <div
            class="contenedor-dato"
            style="display: flex; align-items: center"
          >
            <div style="width: 90%; font-weight: bold; white-space: nowrap">
              {{estadoCuenta?.cabeceraEstadoCuenta?.numeroCliente ?? '-'}}
            </div>
          </div>
          <div
            class="contenedor-dato"
            style="display: flex; align-items: center"
          >
            <div style="width: 90%; font-weight: bold; white-space: nowrap">
              {{estadoCuenta?.cabeceraEstadoCuenta?.cuenta ?? '-'}}
            </div>
          </div>
        </div>
      </div>
      <div class="grupo-info" style="width: 50%; padding: 5px;">
        <div class="columna">
          <div class="etiqueta-info" style="font-weight: 100">CI:</div>
          <div class="etiqueta-info" style="font-weight: 100">Producto:</div>
          <div class="etiqueta-info" style="font-weight: 100">
            Fecha Apertura:
          </div>
          <div class="etiqueta-info" style="font-weight: 100">
            Fecha Emisión:
          </div>
        </div>
      </div>
      <div class="grupo-info" style="width: 50% ; padding: 5px;">
        <div class="columna">
          <div
            class="contenedor-dato"
            style="display: flex; align-items: center"
          >
            <div style="width: 90%; font-weight: bold; white-space: nowrap">
              {{estadoCuenta?.cabeceraEstadoCuenta?.cedula ?? '-'}}
            </div>
          </div>
          <div
            class="contenedor-dato"
            style="display: flex; align-items: center"
          >
            <div style="width: 90%; font-weight: bold; white-space: nowrap">
              {{estadoCuenta?.cabeceraEstadoCuenta?.producto ?? '-'}}
            </div>
          </div>
          <div
            class="contenedor-dato"
            style="display: flex; align-items: center"
          >
            <div style="width: 90%; font-weight: bold; white-space: nowrap">
              {{ estadoCuenta?.cabeceraEstadoCuenta?.fechaApertura | date:'yyyy-MM-dd' }}

            </div>
          </div>
          <div
            class="contenedor-dato"
            style="display: flex; align-items: center"
          >
            <div style="width: 90%; font-weight: bold; white-space: nowrap">
              {{ currentDate | date:'yyyy-MM-dd'  }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <table
      class="detalle"
      style="width: 100%; margin-bottom: 20px; font-size: 10px"
    >
      <thead>
        <tr>
          <th style="border-left: 1px solid black; border-top: 1px solid black; border-bottom: 1px solid black; padding: 4px">
            Fecha Movimiento
          </th>
          <th style=" border-left: 1px solid black; border-top: 1px solid black; border-bottom: 1px solid black; padding: 4px">Sucursal</th>
          <th style="border-left: 1px solid black; border-top: 1px solid black; border-bottom: 1px solid black; padding: 4px">Asiento</th>
          <th style=" border-left: 1px solid black; border-top: 1px solid black; border-bottom: 1px solid black; padding: 4px">Usuario</th>
          <th style=" border-left: 1px solid black; border-top: 1px solid black; border-bottom: 1px solid black; padding: 4px">Trans</th>
          <th style=" border-left: 1px solid black; border-top: 1px solid black; border-bottom: 1px solid black; padding: 4px; width: 40%">
            Concepto
          </th>
          <th style=" border-left: 1px solid black; border-top: 1px solid black; border-bottom: 1px solid black; padding: 4px">Crédito</th>
          <th style=" border-left: 1px solid black; border-top: 1px solid black; border-bottom: 1px solid black; padding: 4px">Débito</th>
          <th style=" border-left: 1px solid black; border-top: 1px solid black; border-bottom: 1px solid black; padding: 4px">Cheq.</th>
          <th style=" border-left: 1px solid black; border-top: 1px solid black; border-bottom: 1px solid black; padding: 4px">Efect.</th>
          <th style=" border: 1px solid black; padding: 4px">Contable</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let movimiento of estadoCuenta?.detalleEstadoCuenta ?? []">
          <td
            style="
              border-left: 1px solid black;
              border-bottom: 1px solid black;
              padding: 4px;
            "
          >
            {{ movimiento.fechaMaquina }}
          </td>
          <td
            style="
              border-left: 1px solid black;
              border-bottom: 1px solid black;
              padding: 4px;
            "
          >
            {{ movimiento.oficina }}
          </td>
          <td
            style="
              border-left: 1px solid black;
              border-bottom: 1px solid black;
              padding: 4px;
            "
          >
            {{ movimiento.asiento }}
          </td>
          <td
            style="
              border-left: 1px solid black;
              border-bottom: 1px solid black;
              padding: 4px;
            "
          >
            {{ movimiento.alias }}
          </td>
          <td
            style="
              border-left: 1px solid black;
              border-bottom: 1px solid black;
              padding: 4px;
            "
          >
            {{ movimiento.siglas }}
          </td>
          <td
            style="
              border-left: 1px solid black;
              border-bottom: 1px solid black;
              padding: 4px;
            "
          >
            {{ movimiento.concepto }}
          </td>
          <td
            style="
              border-left: 1px solid black;
              border-bottom: 1px solid black;
              padding: 4px;
            "
          >
          {{ !movimiento.esDebito ? (movimiento.valor | currency) : (0 | currency)}}
        
          </td>
          <td
            style="
              border-left: 1px solid black;
              border-bottom: 1px solid black;
              padding: 4px;
            "
          >
            {{  movimiento.esDebito ? (movimiento.valor | currency) : (0  | currency)}}
          </td>
          <td
            style="
              border-left: 1px solid black;
              border-bottom: 1px solid black;
              padding: 4px;
            "
          >
            {{ movimiento.saldoRetencion |currency }}
          </td>
          <td
            style="
              border-left: 1px solid black;
              border-bottom: 1px solid black;
              padding: 4px;
            "
          >
            {{ movimiento.saldoCuentaDisponible | currency}}
          </td>
          <td
            style="
              border-left: 1px solid black;
              border-right: 1px solid black;
              border-bottom: 1px solid black;
              padding: 4px;
            "
          >
            {{ movimiento.saldoContable | currency }}
          </td>
        </tr>
      </tbody>
    </table>

    <table style="width: 100%; border-collapse: collapse;">
      <tr>
        <th style="text-align: right; font-size: 12px; vertical-align: bottom;">Saldo Bloqueado:</th>
        <th style="text-align: right; font-size: 12px; vertical-align: bottom;">Saldo Disponible:</th>
        <th style="text-align: right; font-size: 12px; vertical-align: bottom;">Saldo Contable:</th>
      </tr>
      <tr>
        <td style="text-align: right; vertical-align: bottom;">
          <div style="font-size: 10px; font-weight: bold;">{{ estadoCuenta?.saldoBloqueado | currency }}</div>
        </td>
        <td style="text-align: right; vertical-align: bottom;">
          <div style="font-size: 10px; font-weight: bold;">{{ estadoCuenta?.saldoDisponible | currency }}</div>
        </td>
        <td style="text-align: right; vertical-align: bottom;">
          <div style="font-size: 10px; font-weight: bold;">{{ estadoCuenta?.saldoContable | currency }}</div>
        </td>
      </tr>
    </table>
    
</div>
</div>


